(function() { window.GUID_57ab0053_875d_46f3_b76c_f83d9ebd4b9f = { getGuid: function() { return "57ab0053-875d-46f3-b76c-f83d9ebd4b9f"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    const matchDetailsGamesTourSelector = "#cstour-match-details-games-tcsr-tour";
                    const matchDetailsGamesTourTargetSelector = "#match-details-games-tcsr-tour-target";
                    const matchDetailsGamesTourDbName = "MatchDetailsGamesTcsrTourState";
                    const matchDetailsGamesTourNamespace = "match-details";
                    const matchDetailsGamesTourSeenKey = "match-details-games-tcsr-tour-target";
                    const matchDetailsGamesTourStateDataKey = "match-details-games-tour-state";
                    const frozenCsrTourSettledWindowKey = "__matchDetailsFrozenCsrTourSettled";
                    const frozenCsrTourSettledEventName = "match-details:frozen-csr-tour-settled";
                    function getMatchDetailsGamesTourStore() {
                        return CS.IDB.createKV({
                            dbName: matchDetailsGamesTourDbName,
                        }).withNamespace(matchDetailsGamesTourNamespace);
                    }
                    function isFrozenCsrTourSettled() {
                        const settledState = window[frozenCsrTourSettledWindowKey];
                        const hasFrozenTourControl = $("#cstour-match-details-frozen-csr-tour").length > 0;
                        if (settledState === "true") {
                            return true;
                        }
                        if (settledState === "false") {
                            return false;
                        }
                        if (settledState === true) {
                            return true;
                        }
                        if (settledState === false) {
                            return false;
                        }
                        return !hasFrozenTourControl;
                    }
                    function scheduleMatchDetailsGamesTourStart(accordion) {
                        const $tourControl = accordion.$Content.find(matchDetailsGamesTourSelector);
                        const $target = accordion.$Content.find(matchDetailsGamesTourTargetSelector);
                        if (!$tourControl.length || !$target.length) {
                            return;
                        }
                        const currentState = accordion.$Container.data(matchDetailsGamesTourStateDataKey);
                        if (currentState === "waiting" ||
                            currentState === "started" ||
                            currentState === "completed") {
                            return;
                        }
                        const tryStartTourAsync = () => __awaiter(this, void 0, void 0, function* () {
                            const latestState = accordion.$Container.data(matchDetailsGamesTourStateDataKey);
                            if (latestState === "started" || latestState === "completed") {
                                return;
                            }
                            let hasSeenTour = false;
                            try {
                                hasSeenTour = yield getMatchDetailsGamesTourStore().has(matchDetailsGamesTourSeenKey);
                            }
                            catch (_a) {
                            }
                            if (hasSeenTour) {
                                accordion.$Container.data(matchDetailsGamesTourStateDataKey, "completed");
                                return;
                            }
                            const tour = CS.Controls.GetInstance(CS.Controls.Tour, matchDetailsGamesTourSelector, true);
                            const $currentTarget = accordion.$Content.find(matchDetailsGamesTourTargetSelector);
                            if (tour == null || !$currentTarget.length) {
                                accordion.$Container.data(matchDetailsGamesTourStateDataKey, "idle");
                                return;
                            }
                            accordion.$Container.data(matchDetailsGamesTourStateDataKey, "started");
                            CS.Controls.Tour.Events.Closed({
                                selector: matchDetailsGamesTourSelector,
                                callback: (t, e) => __awaiter(this, void 0, void 0, function* () {
                                    try {
                                        yield getMatchDetailsGamesTourStore().set(matchDetailsGamesTourSeenKey, {
                                            seen: true,
                                            seenAtUtc: new Date().toISOString(),
                                        });
                                    }
                                    catch (_b) {
                                    }
                                    finally {
                                        accordion.$Container.data(matchDetailsGamesTourStateDataKey, "completed");
                                    }
                                }),
                            });
                            tour.Start();
                        });
                        const deferTourStart = () => {
                            CS.Lag(`match-details-games-tour-start-${accordion.ContentId}`, 50, () => {
                                window.requestAnimationFrame(() => {
                                    tryStartTourAsync();
                                });
                            });
                        };
                        accordion.$Container.data(matchDetailsGamesTourStateDataKey, "waiting");
                        if (isFrozenCsrTourSettled()) {
                            deferTourStart();
                            return;
                        }
                        const handleFrozenCsrTourSettled = () => {
                            window.removeEventListener(frozenCsrTourSettledEventName, handleFrozenCsrTourSettled);
                            deferTourStart();
                        };
                        window.addEventListener(frozenCsrTourSettledEventName, handleFrozenCsrTourSettled);
                    }
                    function tryScheduleMatchDetailsGamesTourStart(accordion) {
                        if (accordion == null || !accordion.IsExpanded) {
                            return;
                        }
                        scheduleMatchDetailsGamesTourStart(accordion);
                    }
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-games",
                        callback: (accordion, e) => {
                            //accordion.SetContentSticky(accordion.$Content.find(".round__header"));
                            //const $allGameBodies = ($except: JQuery) => {
                            //    return accordion.$Content.find(".game__body").not($except);
                            //};
                            const isInPopup = accordion.$Content.closest("#popup-select-game-to-stream").length > 0;
                            if (!isInPopup) {
                                accordion.$Content.offon("click.toggleGame", ".game__header", (e) => {
                                    const $target = $(e.target);
                                    if (!$target.closest(".is-streaming-button").length) {
                                        const $gameHeader = $(e.currentTarget);
                                        const $game = $gameHeader.closest(".game");
                                        //const $gameBody = $game.find(".game__body");
                                        //if ($gameBody.is(":visible")) {
                                        //    $gameBody.slideUp();
                                        //} else {
                                        //    $allGameBodies($gameBody).slideUp();
                                        //    if ($gameBody.length) {
                                        //        $gameBody.slideDown();
                                        //        //$gameBody.css({ display: "flex" });
                                        //    }
                                        //}
                                        const data = $game.data("html");
                                        if (data.url) {
                                            CS.Controls.Popup.ShowAjaxModal(data.url, null, ({ popup, isPopup }) => {
                                                if (!isPopup) {
                                                    return;
                                                }
                                                console.log("GameOptionsPopup");
                                                popup.$Control.offon("click.gameIsStreaming", ".is-streaming-button, .has-videos-button", (e) => {
                                                    CS.Views.MasterPage.ScrollToSection($(".accordion-videostreams"));
                                                    popup.Close();
                                                });
                                                popup.$Control.offon("click.streamGame", ".button-stream-game, .button-add-video-game", (e) => {
                                                    CS.Stream.showStreamingPopup(data, $(e.target).hasClass(".button-add-video-game"));
                                                    popup.Close();
                                                });
                                            }, ({ popup }) => {
                                                // Popup closed
                                            }, true);
                                        }
                                    }
                                });
                            }
                            CS.Controls.Button.Events.Clicked({
                                selector: accordion.$Content,
                                childSelector: ".is-streaming-button",
                                callback: (button, e) => {
                                    CS.Views.MasterPage.ScrollToSection($(".accordion-videostreams"));
                                },
                            });
                            const $tabMenu = accordion.$Content.find(`#tabmenu-games-section-tab-menu-${accordion.ContentId}`);
                            function toggleGamesVisibility($activeTab) {
                                $activeTab.addClass("is-highlighted");
                                const $siblings = $activeTab.siblings();
                                $siblings.removeClass("is-highlighted");
                                const id = $activeTab.attr("id");
                                const $roundsContainer = $activeTab
                                    .closest(".accordion-games")
                                    .find(".rounds");
                                if ($roundsContainer.length) {
                                    if (id) {
                                        if (id === "my-games") {
                                            $roundsContainer.addClass("my-games");
                                        }
                                        else {
                                            $roundsContainer.removeClass("my-games");
                                        }
                                    }
                                    const $rounds = $roundsContainer.find(".round");
                                    $rounds.each((i, round) => {
                                        const $games = $(round).find(".game");
                                        const $visibleGames = $games.filter((i, game) => {
                                            return $(game).css("display") !== "none";
                                        });
                                        if ($visibleGames.length) {
                                            $(round).show();
                                        }
                                        else {
                                            $(round).hide();
                                        }
                                    });
                                }
                            }
                            if ($tabMenu.length) {
                                const $defaultTab = $tabMenu.find(".tab-menu-item.is-highlighted");
                                toggleGamesVisibility($defaultTab);
                                $tabMenu.offon("click.gamesSection", ".tab-menu-item", (e) => {
                                    const $item = $(e.currentTarget);
                                    toggleGamesVisibility($item);
                                });
                            }
                        },
                    });
                    CS.Controls.Accordion.Events.Rendered({
                        selector: "body",
                        childSelector: ".accordion-games",
                        callback: (accordion, e) => {
                            tryScheduleMatchDetailsGamesTourStart(accordion);
                        },
                    });
                    CS.Controls.Accordion.Events.ExpandedCollapsed({
                        selector: "body",
                        childSelector: ".accordion-games",
                        callback: (accordion, e) => {
                            tryScheduleMatchDetailsGamesTourStart(accordion);
                        },
                    });
                    CS.Controls.Tour.Events.Ready({
                        selector: "body",
                        childSelector: matchDetailsGamesTourSelector,
                        callback: (tour, e) => {
                            const $accordionContainer = tour.$Control.closest(".accordion-container");
                            if (!$accordionContainer.length) {
                                return;
                            }
                            const accordion = CS.Controls.GetInstance(CS.Controls.Accordion, $accordionContainer, true);
                            tryScheduleMatchDetailsGamesTourStart(accordion);
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
